import ScrollManager from "@web/vpt-assets/assets/js/utilities/scrollManager";
import FormValidator from "@web/vpt-assets/assets/js/utilities/validations/formValidator";

export default class ClientReplyFormValidator {
    constructor() {
        this.scrollManager = new ScrollManager();
        this.form = document.querySelector('#form_contestar');
        if (!this.form) {
            return;
        }
        this.formValidator = new FormValidator(this.form);
        this.eventDelegation();
    }

    eventDelegation() {
        // The maximum number of options
        const MAX_OPTIONS = 8;

        const ibanInput = this.form.querySelector('[name="iban-input"]');
        const swiftInput = this.form.querySelector('[name="swift-input"]');
        const contactError = $('#contactError');
        if (ibanInput) {
            ibanInput.addEventListener('input', (e) => {
                const validateForm = this.form.querySelector('[data-action="validate-form"]');
                validateForm.removeAttribute('disabled');
                validateForm.classList.remove('disabled');
                contactError.empty();
            });
        }

        if (swiftInput) {
            swiftInput.addEventListener('input', (e) => {
                const validateForm = this.form.querySelector('[data-action="validate-form"]');
                validateForm.removeAttribute('disabled');
                validateForm.classList.remove('disabled');
                contactError.empty();
            });
        }

        $("#form_contestar")
            .formValidation({
                framework: 'bootstrap',
                icon: myApp.formValidator.getFeedbackIcons(),
                fields: {
                    aceptacion: {
                        enabled: true,
                    },
                    observaciones_contacto: {
                        enabled: true,
                    },
                    'attachment[]': {
                        enabled: true, validators: {
                            file: {
                                extension: 'jpeg,jpg,png,gif,pdf,doc,docx,doc,txt,odt,xls,csv,rtf,xps',
                                type: 'image/jpeg,image/png,image/gif,application/pdf,text/plain,application/msword,application/vnd.ms-excel,application/rtf',
                                maxSize: 5242880, // 5 MB
                                message: myApp.translator['forms.clientreply.errors.validation.invalid.attachment']
                            }
                        }
                    }
                }
            })
            .on('change', '[name="attachment[]"]', function (e) {
                $('#form_contestar').formValidation('enableFieldValidators', 'observaciones', false);
                $('#form_contestar').formValidation('revalidateField', 'observaciones');
            })
            // Add button click handler
            .on('click', '.addButton', function () {
                var $newAttach = $('#newAttachment'), $clone = $newAttach
                    .clone()
                    .removeClass('hide')
                    .removeAttr('id')
                    .insertBefore($newAttach), $option = $clone.find('[name="attachment[]"]');

                // Add new field
                $('#form_contestar').formValidation('addField', $option);
            })

            // Remove button click handler
            .on('click', '.removeButton', function () {
                var $row = $(this).parents('.form-group'), $option = $row.find('[name="attachment[]"]');

                // Remove element containing the option
                $row.remove();

                // Remove field
                $('#form_contestar').formValidation('removeField', $option);
            })

            // Called after adding new field
            .on('added.field.fv', function (e, data) {
                // data.field   --> The field name
                // data.element --> The new field element
                // data.options --> The new field options

                if (data.field === 'attachment[]') {
                    if ($('#form_contestar').find(':visible[name="attachment[]"]').length >= MAX_OPTIONS) {
                        const addButton = $('#form_contestar').find('.addButton');
                        addButton.attr('disabled', 'disabled');
                        addButton.addClass('disabled');
                    }
                }
            })
            // Called after removing the field
            .on('removed.field.fv', function (e, data) {
                if (data.field === 'attachment[]') {
                    if ($('#form_contestar').find(':visible[name="attachment[]"]').length < MAX_OPTIONS) {
                        const addButton = $('#form_contestar').find('.addButton');
                        addButton.removeAttr('disabled');
                        addButton.removeClass('disabled');
                    }
                }
            })
            .on('success.form.fv', (e) => {
                e.preventDefault();
                const form = e.currentTarget;

                if (ibanInput) {
                    const isValid = this.formValidator.validateInput(ibanInput);

                    if (!isValid) {
                        if (contactError.empty()) {
                            contactError.append(myApp.translator['forms.clientreply.errors.validation.invalid.iban']);
                        }
                        return;
                    }
                }
                if (swiftInput) {
                    const isValid = this.formValidator.validateInput(swiftInput);

                    if (!isValid || (ibanInput && ibanInput.value.trim() === "")) {
                        if (contactError.empty()) {
                            contactError.append(myApp.translator['forms.clientreply.errors.validation.invalid.swift']);
                        }
                        return;
                    }
                }

                const validator = $(form).data('formValidation');

                const fieldsToCheck = [
                    'observaciones_contacto',
                    'attachment[]',
                    'aceptacion'
                ];

                let atLeastOneFieldFilled = false;

                fieldsToCheck.forEach(fieldName => {
                    const fieldElements = validator.getFieldElements(fieldName);

                    let isFieldFilled = Array.from(fieldElements).some(input => input.value.trim() !== "");

                    if (ibanInput) {
                        isFieldFilled = isFieldFilled || ibanInput.value.trim() !== "";
                    }

                    if (isFieldFilled) {
                        atLeastOneFieldFilled = true;
                    }
                });

                if (atLeastOneFieldFilled) {
                    validator.defaultSubmit();
                } else {
                    if (contactError.empty()) {
                        contactError.append(myApp.translator['forms.clientreply.errors.validation.invalid.overall']);
                    }
                }
            });
    }
}
